import React from 'react';
import { Toaster } from 'react-hot-toast';

const NotificationProvider = () => (
  <Toaster
    toastOptions={{
      success: {
        style: {
          background: 'linear-gradient(270deg, #E1E2FF 0%, #ECF4FF 100%)',
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        },
        duration: 3 * 1000,
      },
      error: {
        duration: 5 * 1000,
      },
    }}
  />
);

export default NotificationProvider;
